import React, { useState } from "react";
import styles from "../../styles/Docs/Docs.module.css";
import { Arrow } from "../../../public/icons";

export const AttributeCard = ({
  attr,
  errorEditAttr,
}: {
  attr: any;
  errorEditAttr: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={styles.attributeCard}
      style={{
        ...(errorEditAttr?.[attr.id]
          ? { borderColor: "var(--vivid-pink)" }
          : {}),
        overflow: "hidden",
      }}
    >
      <div
        onClick={() => setIsOpen((prev) => !prev)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          padding: "4px 0",
          userSelect: "none",
        }}
      >
        <div className={styles.row} style={{ margin: 0, flex: 1 }}>
          <span className={styles.label}>
            {attr.type ? "Назва атрибуту":"Назва"}
            </span>
          <span
            className={styles.value}
            style={{ fontSize: "14px", fontWeight: "700" }}
          >
            {attr.title}
          </span>
        </div>
        <div
          style={{
            marginRight: "12px",

            color: "var(--disabled-c)",
            transform: isOpen ? "rotate(-90deg)" : "rotate(90deg)",
            transition: "transform .35s ease",
            flexShrink: 0,
          }}
        >
          <Arrow color="var(--disabled-c)" />
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateRows: isOpen ? "1fr" : "0fr",
          transition: "grid-template-rows 0.25s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <div className={styles.infoGrid} style={{ paddingTop: "8px" }}>
            {attr.type && (
              <div className={styles.row}>
                <span className={styles.label}>Тип параметру</span>
                <i className={styles.value}>{attr.type.title}</i>
              </div>
            )}

            {attr.data &&
              Object.entries(attr.data).map(([key, val], index) => (
                <div key={key} className={styles.row}>
                  <span className={styles.label}>Варіант {index + 1}</span>
                  <span className={styles.value}>{val as string}</span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
